/* Dansk katalog for locale-demo-reset-shortcut.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'demoReset.button': 'Nulstil demo',
  'demoReset.title': 'Nulstil demovirksomheden',
  'demoReset.message': 'Dette sletter permanent alle regnskabs- og driftsdata i denne demovirksomhed. Handlingen kan ikke fortrydes.',
  'demoReset.preserved': 'Virksomhedsprofilen, medlemmer, abonnement og integrationsforbindelser bevares.',
  'demoReset.phrase': 'BEKRÆFT',
  'demoReset.typeLabel': 'Skriv {phrase} for at aktivere nulstilling',
  'demoReset.typeHint': 'Kontrollér, at den rigtige demovirksomhed er valgt, før du fortsætter.',
  'demoReset.confirm': 'Slet og nulstil demo',
  'demoReset.complete': 'Demovirksomheden er nulstillet.',
  'demoReset.failed': 'Kunne ikke nulstille demovirksomheden.',
  'demoReset.reason': 'Brugeren bekræftede hurtig nulstilling af demovirksomheden ved at skrive det påkrævede bekræftelsesord.',
  'demoReset.settingTitle': 'Vis genvejsknap til nulstilling',
  'demoReset.settingHelp': 'Viser »Nulstil demo« over SuperPlumma for denne virksomhed. Andre virksomheder på demokontoen styres separat.',
  'demoReset.settingEnabled': 'Genvejsknappen er aktiveret for denne demovirksomhed.',
  'demoReset.settingDisabled': 'Genvejsknappen er deaktiveret.',
});
